import { memo } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import { DateValue } from '@/components/tableDrawer';
import { ColumnsGenerator } from '@/utils/tableUtils';
import { GetBrokerMedicalRequests } from '@/api/endpoints/Broker/BrokerRequest';
import Status from './RowsCells/Status/Status';
import useNavs from '@/hooks/useNavs';
import ActionBtn from '@/components/ActionBtn';
import { CategoryRequestCell } from './RowsCells/RowsData';

const MedicalRequests = () => {
    const { BrokerNav } = useNavs();

    const columns = [
        ColumnsGenerator.SearchableTextCell('groupName'),
        ColumnsGenerator.SearchableTextCell('patientName', "patientName"),
        ColumnsGenerator.CustomCell('category', (original) => <CategoryRequestCell original={original} />),
        ColumnsGenerator.SearchableTextCell('selectedProvider', "provider-name"),
        ColumnsGenerator.CustomCell('requestDate', (original) => <DateValue value={original.requestDate} />),
        ColumnsGenerator.CustomCell('status', (original) => <Status status={{ name: original?.orderStatus, id: original?.orderStatusId }} />),
        ColumnsGenerator.CustomCell('action', (original) =>
            <ActionBtn onApply={() => viewRequestDetails(original)} title="show-details" className="details-info" icon={"fluent:eye-16-filled"} />),
    ]

    const viewRequestDetails = (original) =>
        BrokerNav(`medical-requests/${original?.id}`)

    return (
        <ReportContent
            tableAPI={GetBrokerMedicalRequests}
            columns={columns}>

            <ReportHeader> <ReportSearch /> </ReportHeader>

        </ReportContent>
    );
}

export default memo(MedicalRequests);